export default "__VITE_ASSET__CZbtcqud__"